import { useEffect } from 'react';
import { useParams } from 'react-router';

interface UseAccountPageTitleProps {
  accountData: {
    name?: string;
  };
}

export const useAccountPageTitle = ({ accountData }: UseAccountPageTitleProps) => {
  const { tab, id } = useParams<{ tab?: string; id?: string }>();

  useEffect(() => {
    if (!accountData.name) {
      // Если имя аккаунта еще не загружено, показываем общий тайтл
      if (tab) {
        const tabTitles: Record<string, string> = {
          access: 'Доступ',
          public: 'Публичный контент',
          work: 'Рабочий контент',
          offer: 'Ваш оффер',
          campaigns: 'Кампании',
          bills: 'Счета',
          guarantee: 'Гарант',
        };
        const tabTitle = tabTitles[tab] || tab;
        document.title = `Аккаунт - ${tabTitle} | OnlyU`;
      } else {
        document.title = 'Аккаунт | OnlyU';
      }
      return;
    }

    // Если есть имя аккаунта, формируем тайтл
    let title = accountData.name;

    if (tab) {
      const tabTitles: Record<string, string> = {
        access: 'Доступ',
        public: 'Публичный контент',
        work: 'Рабочий контент',
        offer: 'Ваш оффер',
        campaigns: 'Кампании',
        bills: 'Счета',
        guarantee: 'Гарант',
      };
      const tabTitle = tabTitles[tab] || tab;
      title = `${accountData.name} - ${tabTitle}`;
    }

    document.title = `${title} | OnlyU`;
  }, [accountData.name, tab, id]);
};

export default useAccountPageTitle;
